import PickUpSeguimiento from "./PickUpSeguimiento";

export default PickUpSeguimiento;
